/**
 * Capitalizes the first letter of the string
 *
 * @param {String} string
 * @returns {String}
 */
export default function capitalizeString(string) {
  return string.charAt(0).toLocaleUpperCase() + string.slice(1).toLocaleLowerCase()
}
